export default [
  {
    path: 'file-update/:id/version',
    name: 'OldFileUpdateVersion',
    component: () => import('@/views/File/CurrentVersionUpdate.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-file',
      template: 'auth',
    },
  },
  {
    path: 'file-folder/:folderId',
    name: 'fileFolder',
    component: () => import('@/views/File/Index.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-file',
      template: 'auth',
    },
  },
  {
    path: 'files',
    name: 'files',
    component: () => import('@/views/File/Index.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-file',
      template: 'auth',
    },
  },
  {
    path: 'file-create-basic',
    name: 'fileCreate',
    component: () => import('@/views/File/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-file',
      template: 'auth',
    },
  },
  {
    path: 'file-content/:id',
    name: 'fileContent',
    component: () => import('@/views/File/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-file',
      template: 'auth',
    },
  },
  {
    path: 'file/:id/file-update-version',
    name: 'fileUpdateVersion',
    component: () => import('@/views/File/CurrentVersionUpdate.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-file',
      template: 'auth',
    },
  },
  {
    path: 'file/:id/file-create-version',
    name: 'fileCreateVersion',
    component: () => import('@/views/File/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-file',
      template: 'auth',
    },
  },
];
